export const generateSchoolId = (name = '', region = '') => {
  const id = name
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

  return id && region ? `${id}_${region.toLowerCase()}` : id;
};
